/*global self*/
/*global caches*/
/*global clients*/
/*global fetch*/
/*global location*/
var CACHE_VERSION = 1;
var API_CACHE = 'api_chache_' + CACHE_VERSION;
var ASSETS_CACHE = 'assets_cache' + CACHE_VERSION;
var assetsRegExp = [ /\.js$/, /\.css$/, /\.jpg$/, /\.png$/, /\.woff2/ ];
function isAssets(url) {
    return assetsRegExp.some(function(regExp) {
        return regExp.test(url);
    });
}
function isResponseCachable(response) {
    var prodTest =
    location.hostname === 'localhost' || location.hostname === '192.168.200.168'
        ? new RegExp(location.hostname).test(response.url)
        : response.type === 'basic';
    var isProfile = /api\/profile\/\w+/.test(response.url);

    return response && response.ok && prodTest && !isProfile;
}
function fetchAndCache(request, cacheName) {
    var clonedRequest = request.clone();
    return fetch(clonedRequest).then(function(response) {
        if (clonedRequest.method !== 'GET' || !isResponseCachable(response)) {
            return response;
        }
        var responseToCache = response.clone();
        caches.open(cacheName).then(function(cache) {
            cache.put(request, responseToCache);
        });
        return response;
    });
}
self.addEventListener('activate', function() {
    caches.keys().then(function(cs) {
        cs.forEach(function(c) {
            caches.delete(c);
        });
    });
    clients.claim();
});
self.addEventListener('fetch', function(event) {
    var CACHE_NAME;
    if (isAssets(event.request.url)) {
        CACHE_NAME = ASSETS_CACHE;
    } else {
        CACHE_NAME = API_CACHE;
    }
    var promise = caches.match(event.request).then(function(response) {
        if (response) {
            fetchAndCache(event.request, CACHE_NAME);
            return response;
        }
        return fetchAndCache(event.request, CACHE_NAME);
    });

    event.respondWith(promise);
});
